import { render } from "./SuggestView.vue?vue&type=template&id=8b82eb42"
import script from "./SuggestView.vue?vue&type=script&lang=js"
export * from "./SuggestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__